//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import COMMON_METHODS from '@mixins/common-methods.js';

import settlementDatail from '../bill/components/settlementDatail.vue';

export default {
    mixins: [COMMON_METHODS],
    components: {
        settlementDatail,
    },
    props: {},
    data() {
        return {
            settleOrderList: [],
        };
    },
    computed: {
        productId: function () {
            return this.getQuery('productId');
        },
        projectCode: function () {
            return this.getQuery('projectCode');
        },
    },
    watch: {},
    methods: {
        getDetail: function () {
            this.$get(
                `${this.$store.getters.indexUrl}/settle/settProject/projectOrderAllPage`,
                {
                    productId: this.productId,
                    projectCode: this.projectCode,
                },
                function (data) {
                    this.settleOrderList = data;
                }
            );
        },
        //返回
        goBack: function () {
            this.$router.go(-1);
        },
    },
    mounted: function () {
        this.getDetail();
    },
};
